export const questionsTypeOption  = Object.freeze([
    {
      value: "radio",
      label: "单选题"
    },
    {
      value: "checkbox",
      label: "多选题"
    },
    {
      value: "textarea",
      label: "文本题"
    },
    {
      value: "star",
      label: "打分题"
    },
    {
      value: "select",
      label: "下拉题"
    },
    {
      value: "sort",
      label: "排序题"
    },
    {
      value: "upload",
      label: "附件题"
    },
    {
      value: "matrixRadio",
      label: "矩阵单选题"
    },
    {
      value: "matrixCheckbox",
      label: "矩阵多选题"
    },
    {
      value: "matrixStar",
      label: "矩阵打分题"
    },
    {
      value: "chainedSelects",
      label: "联动题"
    },
    {
      value: "textMultiple",
      label: "填空题"
    },
    {
      value: "date",
      label: "日期题"
    },
    {
      value: "region",
      label: "区域题"
    }
  ]);

  export const letterMap = Object.freeze([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ]);


  export const quesTypeMap = Object.freeze({
    radio: "单选题",
    checkbox: "多选题",
    textarea: "文本题",
    star: "打分题",
    select: "下拉题",
    sort: "排序题",
    upload: "附件题",
    matrixRadio: "矩阵单选题",
    matrixCheckbox: "矩阵多选题",
    matrixStar: "矩阵打分题",
    chainedSelects: "联动题",
    textMultiple: "填空题",
    date: "日期题",
    region: "区域题"
  });

  export const examQuesType = Object.freeze([
    "radio",
    "checkbox",
    "select",
    "description",
    "textMultiple"
  ]);

  export const uploadImgType = ["png", "jpg", "jpeg"];
  
  export const uploadPdfType = ["pdf"];




// WEBPACK FOOTER //
// ./src/utils/constant.js